module.exports = __webpack_public_path__ + "img/bancoob.c0a5e384.svg";